export default __webpack_public_path__ + "static/media/UserAgreement.42c27251.svg";